export default __webpack_public_path__ + "static/media/deleteRequestIcon.7f35dbc4.svg";